document.addEventListener("DOMContentLoaded", function () {
  const forms = document.querySelectorAll(".djw-form");

  forms.forEach((form) => {
    const dateInput = form.querySelector(".date-input");
    const formattedDateInput = form.querySelector(".formatted-date-input");
    const recaptchaResponseInput = form.querySelector(".g-recaptcha-response");

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      // Format date safely
      if (dateInput && formattedDateInput) {
        if (dateInput.value) {
          const [year, month, day] = dateInput.value.split("-");
          formattedDateInput.value = `${day}-${month}-${year}`;
        } else {
          formattedDateInput.value = "";
        }
      }

      // reCAPTCHA logic scoped to this form
      if (recaptchaResponseInput) {
        grecaptcha.ready(function () {
          grecaptcha
            .execute("6Les66kUAAAAANyLrgkl7iuN4JUpNlB5upaMovI4", {
              action: "submit",
            })
            .then(function (token) {
              recaptchaResponseInput.value = token;
              form.submit();
            });
        });
      } else {
        console.warn("Missing .g-recaptcha-response input in form", form);
      }
    });
  });
});
